import React, { useState } from 'react';
import ImageUpload from './components/ImageUpload';
import Results from './components/Results';
import './App.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import FontAwesome
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; // Import back arrow icon

const App = () => {
    const [resultData, setResultData] = useState(null);

    const handleDetection = (data) => {
        setResultData(data);
    };

    // Handle back button click
    const handleBackClick = () => {
        window.location.href = "https://krishi-mitra-eight.vercel.app/"; // Redirect to the specified URL
    };

    return (
        <div className="App relative">
            <button
                onClick={handleBackClick}
                className="absolute top-4 left-4 bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition-all duration-300"
            >
                <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <h1>Plant Disease Detector</h1>
            <ImageUpload onDetect={handleDetection} />
            <Results data={resultData} />
        </div>
    );
};

export default App;
